<app-loader *ngIf="loader"></app-loader>
<section class="profile_section">
  <nav class="navbar navbar-expand-lg navbar-light transparent mt-2">
    <div class="col-12 p-0 d-flex align-items-center justify-content-between">
      <a routerLink="/dashboard">
        <img src="../../../assets/img/redback.png" alt="back" /><span
          class="title_get ml-2"
          >Back</span
        ></a
      >
      <span class="font-weight-bold text-dark">Account Info</span>
      <a class="title_get" routerLink="/edit-profile">EDIT</a>
    </div>
  </nav>

  <div class="container mt-5 profile__container">
    <div class="row">
      <div class="col-12">
        <img
          src="https://www.w3schools.com/howto/img_avatar.png"
          alt="Avatar"
          class="avatar"
        />
        <p class="text-dark mb-0 mt-2 text-center" *ngIf="profile">
          {{ profile.displayName }}
        </p>
        <p class="text-dark mb-0 text-center" *ngIf="profile">
          {{ profile.mobile }}
        </p>
      </div>
    </div>
  </div>
  <div class="container profile__details__container mt-5">
    <div class="row mt-3">
      <div class="col-6">User since</div>
      <div class="col-6 d-flex justify-content-end text__details">
        {{ created }}
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-6">Email ID</div>
      <div
        class="col-6 d-flex justify-content-end text__details"
        *ngIf="profile"
      >
        {{ profile.email }}
      </div>
    </div>
    <div class="row mt-3" *ngFor="let meter of bot; let i = index">
      <div class="col-6">Bot {{ i + 1 }}</div>
      <div class="col-6 d-flex justify-content-end text__details">
        {{ bot[i] }}
      </div>
    </div>
  </div>
</section>
<app-bottom-navbar></app-bottom-navbar>
